export function s3FileOpener(link, type) {
  const openedTabs = parseInt(window.localStorage.getItem('OPEN_TABS')) || 1
  window.localStorage.setItem('OPEN_TABS', openedTabs + 1)

  if (type && type === 'pdfReports') {
    window.open(link, '_blank')
  } else {
    window.location = link
  }
}
